

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AccountingEntryTax_ManagedObject

class AccountingEntryTax_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: kind
    set kind(value:number) {
        this.setValueForKey(value, 'kind');
    }
    get kind():number {
        return this.valueForKey('kind');
    }
    set kindPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'kind');
    }
    get kindPrimitiveValue():number {
        return this.primitiveValueForKey('kind');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: rate
    set rate(value:number) {
        this.setValueForKey(value, 'rate');
    }
    get rate():number {
        return this.valueForKey('rate');
    }
    set ratePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'rate');
    }
    get ratePrimitiveValue():number {
        return this.primitiveValueForKey('rate');
    }

    // Property: taxEntityID
    set taxEntityID(value:string) {
        this.setValueForKey(value, 'taxEntityID');
    }
    get taxEntityID():string {
        return this.valueForKey('taxEntityID');
    }
    set taxEntityIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'taxEntityID');
    }
    get taxEntityIDPrimitiveValue():string {
        return this.primitiveValueForKey('taxEntityID');
    }

    // Property: taxEntityName
    set taxEntityName(value:string) {
        this.setValueForKey(value, 'taxEntityName');
    }
    get taxEntityName():string {
        return this.valueForKey('taxEntityName');
    }
    set taxEntityNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'taxEntityName');
    }
    get taxEntityNamePrimitiveValue():string {
        return this.primitiveValueForKey('taxEntityName');
    }
    // Relationship: entry
    set entry(value:AccountingEntry) {
        this.setValueForKey(value, 'entry');
    }
    get entry():AccountingEntry {
        return this.valueForKey('entry') as AccountingEntry;
    }
}
